import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listInvoices, markPaid, cancelInvoice } from "../api/invoices";

const EmployeeInvoiceList = () => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const loadInvoices = async () => {
        try {
            setLoading(true);
            setError("");
            const data = await listInvoices();
            setInvoices(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(err?.message || "Failed to load invoices.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadInvoices();
    }, []);

    const handleMarkPaid = async (id) => {
        await markPaid(id);
        await loadInvoices();
    };

    const handleCancel = async (id) => {
        if (!window.confirm("Cancel this invoice?")) return;
        await cancelInvoice(id);
        await loadInvoices();
    };

    if (loading) return <p>Loading invoices...</p>;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="p-6 max-w-5xl mx-auto">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Invoices</h2>

                <button
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                    onClick={() => navigate("create")}
                >
                    Create invoice
                </button>
            </div>

            {invoices.length === 0 ? (
                <p className="text-gray-500">No invoices found.</p>
            ) : (
                <table className="w-full border text-sm">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border p-2">Number</th>
                            <th className="border p-2">Amount</th>
                            <th className="border p-2">Status</th>
                            <th className="border p-2">Due date</th>
                            <th className="border p-2">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {invoices.map((invoice) => (
                            <tr key={invoice.id}>
                                <td
                                    className="border p-2 text-blue-600 cursor-pointer"
                                    onClick={() => navigate(`${invoice.id}`)}
                                >
                                    {invoice.number || invoice.id}
                                </td>

                                <td className="border p-2">
                                    {invoice.amount} {invoice.currency || "EUR"}
                                </td>

                                <td className="border p-2">
                                    {invoice.status || "�"}
                                </td>

                                <td className="border p-2">
                                    {invoice.dueDate
                                        ? new Date(invoice.dueDate).toLocaleDateString()
                                        : "�"}
                                </td>

                                <td className="border p-2 space-x-2">
                                    <button
                                        className="text-green-600"
                                        onClick={() => handleMarkPaid(invoice.id)}
                                        disabled={invoice.status === "Paid"}
                                    >
                                        Mark paid
                                    </button>

                                    <button
                                        className="text-red-600"
                                        onClick={() => handleCancel(invoice.id)}
                                        disabled={
                                            invoice.status === "Paid" ||
                                            invoice.status === "Cancelled"
                                        }
                                    >
                                        Cancel
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default EmployeeInvoiceList;